@import 'node_modules/@oebb-web-team/oebb-web-library/src/css/accessibility';
@import "../../global/variables";

.best-price {
    text-align: right;
    padding: 1px 4px;
    line-height: 1.0em;
    font-size: 15px;
    margin-right: 10px;
    align-items: center;
    display:inline-flex;
    gap: 7px;

    &--selected {
        background-color: $colour-nightjet-accent;
        color: white;
        border-radius: 3px;

        check-icon {
            display: none;
        }

        @media #{$screen-min-lg} {
            check-icon {
                display: flex;
                justify-content: center;
                align-items: center;
                width: .625rem;
                height: .625rem;
                background-color: $color-white;
                color: $colour-nightjet-accent;
                border-radius: 50%;
            }
        }
    }
}

.best-price seat-icon,
.best-price couchette-icon,
.best-price sleeper-icon {
    vertical-align: middle;
}